import React from "react";
import {
  AutoModeRounded,
  BuildCircleRounded,
  CheckCircleRounded,
  CloudDoneRounded,
  DonutLargeRounded,
  FactCheckRounded,
  FlipCameraAndroidRounded,
} from "@mui/icons-material";
import { Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useThemeSettings } from "../../../../../theme/ThemeSettingsProvider";

const useStyles = makeStyles()((theme) => ({
  uploaded: {
    backgroundColor: "#ECEFF1",
    color: "#263238",
    "& .MuiChip-icon": {
      color: "#263238",
    },
  },
  processing: {
    backgroundColor: "#E3F2FD",
    color: "#0D47A1",
    "& .MuiChip-icon": {
      color: "#0D47A1",
    },
  },
  reviewing: {
    backgroundColor: "#F3E5F5",
    color: "#4A148C",
    "& .MuiChip-icon": {
      color: "#4A148C",
    },
  },
  reviewed: {
    backgroundColor: "#E8EAF6",
    color: "#1A237E",
    "& .MuiChip-icon": {
      color: "#1A237E",
    },
  },
  indexing: {
    backgroundColor: "#E0F7FA",
    color: "#006064",
    "& .MuiChip-icon": {
      color: "#006064",
    },
  },
  completed: {
    backgroundColor: "#E8F5E9",
    color: "#1B5E20",
    "& .MuiChip-icon": {
      color: "#1B5E20",
    },
  },
  indoramaMonochrome: {
    color: "#CFE7E8",
    background: "rgba(35,224,210,0.08)",
    "& .MuiChip-icon": {
      color: "#6CF2E6",
    },
  },
}));

export const fileStatus = {
  all: { label: "Uploaded", icon: DonutLargeRounded },
  uploaded: { label: "Initializing", icon: BuildCircleRounded },
  processing: { label: "Processing", icon: BuildCircleRounded },
  reviewing: { label: "Reviewing", icon: FlipCameraAndroidRounded },
  // reviewed: { label: "Reviewed", icon: FactCheckRounded },
  indexing: { label: "Indexing", icon: AutoModeRounded },
  completed: { label: "Completed", icon: CheckCircleRounded },
};

function FileStatus({ status }) {
  const { mode } = useThemeSettings();
  const isDarkMode = mode === "dark";
  const { classes } = useStyles();
  const processedStatus = fileStatus[status] ? status : "all";
  const Icon = fileStatus[processedStatus]?.icon;
  return (
    <Chip
      label={fileStatus[processedStatus]?.label}
      icon={<Icon />}
      className={
        isDarkMode ? classes.indoramaMonochrome : classes[processedStatus]
      }
    />
  );
}

export default FileStatus;
